var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"top":"0px"}},[_c('p',{staticClass:"time shadow",staticStyle:{"margin":"0px"},domProps:{"textContent":_vm._s(_vm.currentTime)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }